"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMAGE_EXTENSIONS = exports.DOCUMENT_EXTENSIONS = exports.REC_REFERRAL_TOKEN = exports.ASTERISK = exports.PRTV_ALLOWED_TAGS = exports.PRTV_ALLOWED_ATTRIBUTES = void 0;
exports.PRTV_ALLOWED_ATTRIBUTES = {
    "a": ["href", "name", "target", "class", "style"],
    "img": ["src", "alt", "class", "style"],
    "h1": ["class", "style"],
    "h2": ["class", "style"],
    "h3": ["class", "style"],
    "p": ["class", "style"],
    "ul": ["class", "style"],
    "li": ["class", "style"],
    "ol": ["class", "style"],
    "b": ["class", "style"],
    "i": ["class", "style"],
    "strong": ["class", "style"],
    "em": ["class", "style"],
    "strike": ["class", "style"],
    "table": ["class", "style"],
    "thead": ["class", "style"],
    "caption": ["class", "style"],
    "tbody": ["class", "style"],
    "tr": ["class", "style"],
    "th": ["class", "style"],
    "td": ["class", "style"],
    "span": ["class", "style"],
    "div": ["class", "style"]
};
exports.PRTV_ALLOWED_TAGS = ["h1", "h2", "h3", "br", "a", "p", "ul", "li", "ol", "b", "i", "strong", "em", "strike", "table", "thead", "caption", "tbody", "tr", "th", "td", "img", "span", "div", "br", "sup", "sub"];
exports.ASTERISK = '<a style="color: #B74743;">*</a>';
exports.REC_REFERRAL_TOKEN = 'RECReferralToken';
exports.DOCUMENT_EXTENSIONS = ['.docx', '.doc', '.pdf', '.txt'];
exports.IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png'];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/shared/code/Constants.ts
// module id = 14
// module chunks = 0 2